// extracted by mini-css-extract-plugin
export default {"background":"loader_background__16E1u"};